module.exports = __webpack_public_path__ + "static/media/w-qiao-logo.22e3fdd4.jpg";